'use strict';

var GridPricingSummaryFareChangeFilterFactory = function GridPricingSummaryFareChangeFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['PricingSummaryFareChangeByODFilterFactory', 'PricingSummaryFareChangeByPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function GridPricingSummaryFareChangeFilter() {
    DemandFilter.call(this, 'pricing-summary-fare-change', 'pricing-summary-fare-change');
    this.registerFilters(injectedFilters);
  }
  GridPricingSummaryFareChangeFilter.prototype = Object.create(DemandFilter.prototype);
  GridPricingSummaryFareChangeFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return GridPricingSummaryFareChangeFilter;
};
GridPricingSummaryFareChangeFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = GridPricingSummaryFareChangeFilterFactory;